export default __webpack_public_path__ + "static/media/app7-section3-image3.1404a9aa.png";